import {PortableText} from '@portabletext/react'
import {HiMiniArrowRight} from 'react-icons/hi2'
import {Link} from '@tanstack/react-router'
import clsx from 'clsx'
import {
    internalGroqTypeReferenceTo,
    SanityImageCrop,
    SanityImageHotspot,
} from '../../../../sanity.types'
import CmsImage from '~/components/content/CmsImage'

export type TextWithIllustration = {
    _key: string
    _type: 'textWithIllustration'
    title?: string
    description: Array<{
        children?: Array<{
            marks?: Array<string>
            text?: string
            _type: 'span'
            _key: string
        }>
        style?: 'blockquote' | 'h2' | 'h3' | 'h4' | 'normal'
        listItem?: 'bullet' | 'number'
        markDefs?: Array<{
            href?: string
            _type: 'link'
            _key: string
        }>
        level?: number
        _type: 'block'
        _key: string
    }>
    link?: {
        label: string
        link: string
    }
    image: {
        asset?: {
            _ref: string
            _type: 'reference'
            _weak?: boolean
            [internalGroqTypeReferenceTo]?: 'sanity.imageAsset'
        }
        hotspot?: SanityImageHotspot
        crop?: SanityImageCrop
        alt: string
        backgroundColor?: string
        _type: 'image'
    }
}

type TextWithIllustrationColumnProps = TextWithIllustration

const TextWithIllustrationColumn = ({
    image,
    title,
    description,
    link,
}: TextWithIllustrationColumnProps) => {
    return (
        <div className="inline-block w-full">
            <div className="backdrop-blur transform-gpu bg-gray-700/10 max-w-screen-xl md:rounded-2xl mx-auto mt-16 md:mx-3 md:h-[calc(100%_-_4rem)]">
                <div
                    className={clsx(
                        'px-4 md:p-0 mx-auto max-w-screen-xl flex flex-col justify-center gap-6 md:gap-8 md:h-full'
                    )}
                >
                    <div className="relative -mt-16 md:-mx-3 w-full md:w-auto flex-1 mx-auto aspect-[5/3] md:aspect-[3/2]">
                        <CmsImage
                            className="size-full rounded-2xl shadow-2xl object-cover object-center overflow-hidden absolute inset-0"
                            image={image}
                            backgroundColor={image.backgroundColor}
                            mode="cover"
                            sizes="400px"
                            loading="eager"
                        />
                    </div>
                    <div className="mb-6 flex-grow w-full px-4 flex flex-col gap-4">
                        {!!title && <h3 className="text-2xl font-bold">{title}</h3>}
                        <div className="flex-1">
                            <PortableText value={description} />
                        </div>
                        {!!link && (
                            <div>
                                <Link
                                    to={link.link}
                                    className="flex flex-row items-center gap-1 font-medium text-green-600 md:text-lg"
                                >
                                    <span>{link.label}</span>
                                    <HiMiniArrowRight className="size-4 md:size-5" />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TextWithIllustrationColumn
